import React, { useEffect, useRef } from "react";
import { gsap, Power3 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { fadeIn, flyInFromRight, rotateInFromRight } from "./hooks/animations";
import FlyInText from "./FlyInText";
import { Link } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const FeaturesMobile = () => {
  const wrapper = useRef(null);

  useEffect(() => {
    const q = gsap.utils.selector(wrapper);
    const DEV = false;

    // gsap.from(q(".mask-heart"), {
    //   y: 400,
    //   stagger: 0.24,
    //   // delay: 0.2,
    //   scrollTrigger: {
    //     markers: DEV,
    //     trigger: q(".gifts-heading"),
    //     start: "bottom 80%", // when the top of the trigger hits the top of the viewport
    //     endTrigger: q(".wallpapers-heading"),
    //     end: "bottom  60%",
    //     // end after scrolling 500px beyond the start
    //     // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
    //     scrub: 1.05,
    //   },
    // });

    // gsap.from(q(".mask-parallelogram-3"), {
    //   y: 400,
    //   stagger: 0.24,
    //   delay: 0.2,
    //   scrollTrigger: {
    //     markers: DEV,
    //     trigger: q(".wallpapers-heading"),
    //     start: "100px 80%", // when the top of the trigger hits the top of the viewport
    //     endTrigger: q(".carousel"),
    //     end: "bottom bottom",
    //     scrub: 1.05,
    //   },
    // });
    gsap.from(q(".mask-heart"), {
      y: 400,
      stagger: 0.24,
      // delay: 0.2,
      scrollTrigger: {
        markers: DEV,
        trigger: q(".mask-heart"),
        start: "top bottom", // when the top of the trigger hits the top of the viewport
        end: "+=20%",
        // end after scrolling 500px beyond the start
        // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
        scrub: 1.05,
      },
    });

    gsap.from(q(".mask-parallelogram-3"), {
      y: 400,
      stagger: 0.24,
      delay: 0.2,
      scrollTrigger: {
        markers: DEV,
        trigger: q(".mask-parallelogram-3"),
        start: "top bottom", // when the top of the trigger hits the top of the viewport
        end: "+=20%",

        scrub: 1.05,
      },
    });
  }, []);

  return (
    <section ref={wrapper} className="section-padding py-10">
      <div className="flex z-50 flex-col relative items-center justify-center w-full">
        <div className="md:flex md:gap-2 lg:gap-4">
          <FlyInText
            classes="section-heading text-primary text-center gifts-heading mb-0"
            text={"Breathtaking"}
          />
          <FlyInText
            classes="section-heading text-primary text-center gifts-heading"
            text={"Gifts"}
          />
        </div>
        {/* <div className="relative w-full z-20 h-max ">
            <img
              className="transform scale-[120%]  w-full mask mask-heart"
              src="assets/gift.jpg"
              alt="gift wrapped"
            />
            <button className="btn btn-primary btn-outline absolute top-0 bottom-0 text-normal">
              Shop Now
            </button>
          </div> */}
        <div className="relative sm:w-8/12">
          <div className="card w-full bg-base-100 shadow-xl image-full mask mask-heart relative overflow-visible z-10">
            <figure>
              <img src="assets/gift.jpg" alt="gift" />
            </figure>
            <div className="relative card-body flex items-center justify-center ">
              <Link
                to="/products?c=physical"
                className="btn btn-secondary underline btn-outline border-none text-lg transform -translate-y-4 md:text-xl btn-wide rounded-md md:py-2 lg:py-3 hover:shadow-2xl h-max"
              >
                Shop Now
              </Link>
            </div>
          </div>
          <div className="absolute w-full h-full mask mask-heart bg-gradient-to-b from-transparent to-primary opacity-75 -bottom-4 heart-shadow"></div>
          <div className="absolute w-full h-full mask mask-heart bg-base-300 -bottom-2 "></div>
          <div className="heart -bottom-4 left-[65%] animate-float"></div>
          <div
            style={{ "--offset": "5.5s" }}
            className="heart -bottom-4 right-[65%] animate-float"
          ></div>
        </div>
      </div>
      <div className="flex flex-col relative items-center justify-center w-full mt-14 p-0 ">
        <div className="md:flex md:gap-2 lg:gap-4">
          <FlyInText
            classes="z-10 section-heading text-center wallpapers-heading mb-0"
            text={"Stunning"}
          />
          <FlyInText
            classes="z-10 section-heading text-center wallpapers-heading"
            text={"Wallpapers"}
          />
        </div>
        <p className="section-desc text-center">
          Handdrawn digital lettering illustrated with the aspect ratio of your
          choice!
        </p>
        {/* <img
            className="bg-primary transform scale-[150%] brightness-[40%] w-full z-30  mask mask-parallelogram-3 mt-8 "
            src="assets/gift.jpg"
            alt="gift wrapped"
          /> */}
        <div className="relative w-full sm:w-8/12">
          <div className="z-20 card w-full scale-110 bg-base-100 image-full mask mask-parallelogram-3 mt-2">
            <figure>
              <img
                src="assets/sana.jpg"
                alt="wallpaper"
                className="transform -rotate-[24deg]"
              />
            </figure>
            <div className="card-body flex items-center justify-center ">
              <Link
                to="/products?c=digital"
                className="transform scale-[90%] btn btn-secondary underline btn-outline border-none text-lg md:text-xl btn-wide rounded-md md:py-2 lg:py-3 hover:shadow-2xl h-max"
              >
                Shop Digital
              </Link>
            </div>
          </div>
          <div className=" absolute mask mask-parallelogram-3 w-24 h-24 bg-primary -bottom-14 left-10 shadow-inner shadow-2xl bg-primary opacity-25"></div>
          <div className=" absolute mask mask-parallelogram-3 w-24 h-24 bg-primary -top-8 right-4 shadow-inner shadow-2xl bg-primary opacity-25"></div>
          <div className="z-10 absolute w-full h-full mask bg-secondary dots-bg top-3 left-3 mask mask-parallelogram-3 sm:top-4 sm:left-4 md:top-5 md:left-5 lg:top-6 lg:left-6"></div>
          <div className="z-10 absolute w-full h-full mask bg-gradient-to-br from-base-200 top-3 left-3 mask mask-parallelogram-3 sm:top-4 sm:left-4 md:top-5 md:left-5 lg:top-6 lg:left-6"></div>
          <div className="absolute w-full h-full mask bg-primary top-5 left-5 mask-parallelogram-3 sm:top-6 sm:left-6 md:top-7 md:left-7 lg:top-8 lg:left-8"></div>
          {/* <div className=" absolute mask mask-parallelogram-3 w-24 h-24 bg-transparent border border-primary -top-8 left-4 shadow-inner shadow-2xl bg-primary opacity-25"></div> */}
        </div>
      </div>
    </section>
  );
};

export default FeaturesMobile;
